import { MainContainer } from "../../components/Contents/Contents.element";
import { useLoading } from "../../contexts/LoadingContext";
import PageHeader from "../../layout/PageHeader";
import LoadingSpinner from "../../ui/LoadingSpinner";
import { usePlayerSearch } from "../../contexts/SearchPlayersContext";
import { useNotification } from "../../contexts/NotificationContext";
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSidebar } from "../../contexts/SidebarContext";
import ClubSearchInit from "./ClubSearchInit";
import "./clubsearch.css";
import { useClubSearch } from "../../contexts/ClubSearchContext";

const ClubSearchInitiate = () => {
  const {
    setIsFilterChange,
    setTotalRevenue,
    setTotalCost,
    setTotalProfitLoss,
    setTotalDebt,
    setAssetsLiabilities,
    setDebtVsAssetsRatio,
    setTotalIntangibleAssets,
    setTotalReceivables,
    setReceivablesPercentage,
    setRegionValues,
    setClubCurrentPage,
    setSortClubOrderName,
    setSortClubOrdering,
    setAvgSquadValue,
    setSquadPurchaseCostVSValue,
    setAvgSystemFit,
    setAvgPlayerAge
  } = useClubSearch();
  const location = useLocation();
  const { loading } = useLoading();
  const [key, setKey] = useState(0);
  const { isOpen, toggleSubSidebar, subMenuOpen, setActiveItemId, toggleDrawer, drawerState, isBlurred, setIsBlurred } = useSidebar();
  const isFromMenu = location.state?.fromMenu;

  const handleClearAllFields = () => {
    setTotalRevenue({ min: 0, max: 2000000000 });
    setTotalCost({ min: 0, max: 2000000000 });
    setTotalProfitLoss({ min: -500000000, max: 1000000000 });
    setTotalDebt({ min: 0, max: 3000000000 });
    setAssetsLiabilities({ min: 0, max: 10 });
    setDebtVsAssetsRatio({ min: 0, max: 40 });
    setTotalIntangibleAssets({ min: 0, max: 1000000000 });
    setTotalReceivables({ min: 0, max: 1000000000 });
    setReceivablesPercentage({ min: 0, max: 500 });
    setAvgSquadValue({ min: 0, max: 180000000 });
    setSquadPurchaseCostVSValue({ min: 0, max: 180000000 });
    setAvgSystemFit({ min: 0, max: 100 });
    setAvgPlayerAge({ min: 16, max: 55 });
    setRegionValues([]);
    setClubCurrentPage(1);
    setIsFilterChange(false);
    setSortClubOrderName('Revenue');
    setSortClubOrdering('DESC');
    setKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    if (isFromMenu) {
      setKey((prevKey) => prevKey + 1);
    }
  }, [isFromMenu]);

  return (
    <MainContainer isBlurred={isBlurred!} className="main-container player-detail-page">
      <PageHeader
        title="Clubs"
        from="clubsearch"
        clearAllFields={true}
        onClearAllFields={() => {
          handleClearAllFields();
        }}
        clubResultList
      />
      <ClubSearchInit key={key} />
      {loading && <LoadingSpinner />}
    </MainContainer>
  );
};

export default ClubSearchInitiate;
